export const defaultValues = {
  'company-name': '',
  'input-flight-code': '',
  'origin-airport': '',
  'input-ticket-number': '',
  'flight-date': '',
};

export type RequestForm = typeof defaultValues;
